import styled from "@emotion/styled"
import { spacingFluidMd } from "@porsche-design-system/components-react/emotion"
import { Flex, Skeleton } from "src/components"

export const SpecialEquipmentStageSkeleton = () => (
	<Wrapper>
		{Array.from({ length: 2 }, (_, i) => (
			<Flex key={i} $gap="xl">
				<HalfWidth>
					<Skeleton.List entries={5} withHeader />
				</HalfWidth>
				<HalfWidth>
					<Skeleton.List entries={5} withHeader />
				</HalfWidth>
			</Flex>
		))}
	</Wrapper>
)

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${spacingFluidMd};
`

const HalfWidth = styled.div`
	width: 50%;
`
